import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE } from '#constants/message-type.constants.ts';
import { GetUserLeaguePointsRewardsBalance } from '#types/response.types.ts';

export const getUserLeaguePointsRewardsBalance =
  (): Promise<GetUserLeaguePointsRewardsBalance> =>
    SocketAsFetch.fetch({
      message_type: GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE,
    });
